import React from 'react';
import { ScrollText, Package, Handshake, School, 
  GraduationCap, Users,
  LayoutGrid,
  Medal,
  Telescope,
  User,
  FolderSync,
  CircleHelp,
  Bot,
  Boxes, TicketCheck, Citrus, Car, Trophy, TrafficCone, ShoppingBasket, SquareKanban, BookOpen,BookCheck, Book } from 'lucide-react';
import { title } from 'process';
import { Rocket } from '@mui/icons-material';

export interface ISidebarItem {
  title: string;
  icon?: React.ReactNode;
  children?: ISidebarItem[];
  selected?: boolean;
  expanded: boolean;
  level?: number;
  id?: number;
  link?: string;
  parent?: ISidebarItem;
  hasChildren: boolean;
}

export const pageRoutes: ISidebarItem[] = [
  {
    title: 'Dashboard',
    link: `/${process.env.PREFIX}/dashboard`,
    icon: <LayoutGrid />,
    children: []
  },
  {
    title: 'My Courses',
    icon: <BookOpen />,
    children: [
      {
        title: "Enrolled Courses",
        link: `/${process.env.PREFIX}/my-courses`,
      },{
        title: "Course Statistics",
        link: `/${process.env.PREFIX}/course-statistics`,
      },{
        title: "Course Activities",
        link: `/${process.env.PREFIX}/course-activities`,
      }
    ]
  },
  {
    title:"My Contests",
    icon: <Medal />,
    children: [{
      title: "Contests",
      link: `/${process.env.PREFIX}/my-contests`,
    },{
      title: "My Assets",
      link: `/${process.env.PREFIX}/my-assets`,
    }]
  },
  {
    title:"My Learning Tools",
    link: `/${process.env.PREFIX}/my-learning-tools`,
    icon: <Telescope />
  },
  {
    title:"My Leanbot",
    link: `/${process.env.PREFIX}/my-leanbots`,
    icon: <Bot />
  },
  {
    title:"My Twinspace",
    icon: <Rocket />,
    children: [{
      title: "View",
      link: `/${process.env.PREFIX}/my-twinspace`,
    },{
      title: "PMineTest",
      link: `/${process.env.PREFIX}/pminetest`,
    }]
  },
  {
    title:"My Achievement",
    icon: <Trophy />,
    children: [{
      title: "My Badges",
      link: `/${process.env.PREFIX}/my-badges`,
    },{
      title: "My Certificates",
      link: `/${process.env.PREFIX}/my-certificates`,
    },{
      title: "OpenCert FAQ",
      link: `/${process.env.PREFIX}/opencert-faq`,
    }]
  },{
    title:"My Orders",
    icon: <ShoppingBasket />,
    link: `/${process.env.PREFIX}/my-orders`,
    
  },
  {
    title:"My Profile",   
    icon: <User />,
    link: `/${process.env.PREFIX}/my-profile`,
    
  },
  {
    title:"Help",
    icon: <CircleHelp />,
    link: `${process.env.URL_HELP}`,
  },
  {
    id:1000,
    title: 'Switch workspace',
    icon: <FolderSync />,
    children: [{}]
  },
] as any;

var counter = 0;

const setLevelDepth = (item: ISidebarItem, level: number, parent?: ISidebarItem) => {
  item.level = level;
  item.hasChildren = false;
  item.expanded = false;
  item.id = counter++;
  if (parent) {
    item.parent = parent;
  }
  if (item.children && item.children.length > 0) {
    item.hasChildren = true;
    item.children.forEach(child => setLevelDepth(child, level + 1, item));
  }
}

pageRoutes.forEach(item => setLevelDepth(item, 0));